// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
import { CredentialResponse } from '@react-oauth/google';
import Axios, { AxiosRequestConfig } from 'axios';
import { injectable } from 'inversify';
import qs from 'qs';

// Main service class to submit login and obtain tokens from portal-api.
@injectable()
export default class AuthService {
  static diToken = Symbol('auth-service');
  private urlPrefix = '/auth';

  // Send a login request to the remote server.  
  async login(credentials: { username: string; password: string; twofa: string }) {
    try {
      // Post request to remote server and extract tokens from the reply.
      const { data: { access_token, refresh_token } } = await Axios.post(
        this.urlPrefix, 
        qs.stringify({ grant_type: 'password', ...credentials }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      // return the tokens.
      return { accessToken: access_token, refreshToken: refresh_token };
    } 
    catch (err) {
      console.log("****** Exception in Auth-login:", err);
      throw err;
    }
  }

  // Send a logout request to remote server.
  async sendMSLogoutRequest() {
    try {
      const url = `${this.urlPrefix}/ms-logout`;

      console.log("********** in service sendMSLogoutRequest:", url);

      const data = await Axios.get(url);

      // return the tokens.
      return data;

    } 


    catch (err) {
      console.log(`****** Exception in Auth-sendMSLogoutRequest: ${err}`);
      throw err;
    }
  }

  // Send a login request to the remote server using google credentials.  
  // Note: For testing only.  Does not work.
  async loginWithGoogle(credentials: CredentialResponse) {
    try {
      console.log("********** in service loginWithGoogle:", credentials, this);

      const config: AxiosRequestConfig  = {
        method: 'POST',
        url: `${this.urlPrefix}/google`,
        
        headers: {
          'Content-Type': 'application/json', 
        },
        data: credentials
      }
      const { data: { access_token, refresh_token } } = await Axios(config);

      // return the tokens.
      return { accessToken: access_token, refreshToken: refresh_token };
    } 


    catch (err) {
      console.log(`****** Exception in Auth-loginWithGoogle: ${err}`);
      throw err;
    }
  }

  // Send a request to refresh the tokens to the remove server.
  async refreshToken(token: string) {
    try {
      // Post request to remote server and extract tokens from the reply.
      const { data: { access_token, refresh_token } } = await Axios.post(
        this.urlPrefix, 
        qs.stringify({ grant_type: 'refresh_token', refresh_token: token }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      // return the tokens.
      return { accessToken: access_token, refreshToken: refresh_token };
    } 
    catch (err) {
      console.log(`****** Exception in Auth-refreshToken: ${err}`);
      throw err;
    }
  }
}